var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"nlp-nav-btn",attrs:{"disabled":!_vm.apps || !_vm.apps.length || _vm.apps.length !== 1,"color":"blue-grey","small":"","outline":""},on:{"click":_vm.handleClick}},[_c('v-icon',[_vm._v(" south ")]),_vm._v("\n  Import App\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }